import { useLayoutEffect } from 'react';
import type {
  TUseEventBusKey,
  TUseEventbusProps
} from 'utils/generic/event-bus';
import { fireEvent, initEventBus } from 'utils/generic/event-bus/external';

// event type in order to (listen to) or (fire) // Here we can use any type for payload
// eslint-disable-next-line @typescript-eslint/no-explicit-any

/**
 * Hook allows fire and list events between components
 * @param events - events is object with subscribed callbacks where key is eventName, fire on Subject Observable subscribed event
 * @param deps - dependencies for onEvent
 * @returns Function (fireEvent callback)
 */
// Here we can use any type for dependencies
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useExternalEventbus = <
  KeyType extends TUseEventBusKey,
  PayloadType = any
>(
  events?: TUseEventbusProps<KeyType, PayloadType>,
  deps: any[] = []
) => {
  useLayoutEffect(() => {
    // skip useEffect if onEvent is empty
    return initEventBus(events);
  }, deps);

  return {
    // on fireEvent, we should push the event into the eventbus subject's observer
    fireEvent
  };
};
